import { useEffect, useState, useRef } from "react";
import { messageService } from "../services/firebase/messageService";
import { useSignedInUserState, useSignedInState } from "./useAuthState";
import { MessageType } from "../models/message";
import { onMessage } from 'firebase/messaging';
import { messaging } from '../firebase';
import { ProfileType } from "../models/profileType";

export function useActiveMessages(profile: ProfileType | null) {
  const [activeCount, setActiveCount] = useState<number>(0);
  const [messages, setMessages] = useState<MessageType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const signedIn = useSignedInState();

  // Ref to track the initial mount
  const isFirstMount = useRef(true);

  useEffect(() => {
    if (!signedIn || !profile) {
      setActiveCount(0);
      setLoading(false);
      return;
    }

    // Prevent fetching on tab swap
    if (isFirstMount.current) {
      let intervalId: NodeJS.Timeout;

      const fetchActiveMessages = async () => {
        try {
          setLoading(true);
          const messages = await messageService.fetchMessagesByUser(profile);
          setMessages(messages)
          setActiveCount(messages.length);
          setMessages(messages);
          setError(null);
        } catch (_) {
          setError("Failed to fetch active messages");
        } finally {
          setLoading(false);
        }
      };

      fetchActiveMessages(); // fetch immediately

      intervalId = setInterval(() => {
        fetchActiveMessages(); // fetch again every hour
      }, 60 * 60 * 1000); // 1 hour = 60 mins * 60 secs * 1000 ms

      // if there is a notification reload the active messages
      onMessage(messaging, (payload) => {
        fetchActiveMessages(); // fetch again every hour
      });

      isFirstMount.current = false; // Mark as mounted after the first fetch

      return () => clearInterval(intervalId); // clear interval when unmounting
    }
  }, [signedIn, profile]);

  return { activeCount, loading, error, messages, setMessages };
}

